var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScrum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "team-collaboration/management/scrum") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team-collaboration/management/scrum",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#6F2502",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    x: -1,
    y: -1,
    width: 71,
    height: 71,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "time",
    transform: "translate(11.000000, 11.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,8.96484375 C16.4451966,8.96484375 8.96484375,16.4451966 8.96484375,25.5 C8.96484375,34.5544922 16.4451966,42.0351562 25.5,42.0351562 C34.5548034,42.0351562 42.0351562,34.5544922 42.0351562,25.5 C42.0351562,16.4451966 34.5548034,8.96484375 25.5,8.96484375 Z",
    id: "Shape",
    fill: "#7ED8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0351562,25.5 C42.0351562,34.5544922 34.5548034,42.0351562 25.5,42.0351562 L25.5,8.96484375 C34.5548034,8.96484375 42.0351562,16.4451966 42.0351562,25.5 Z",
    id: "Shape",
    fill: "#6AA9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,25.5 C51,31.2371887 49.0277344,36.9849609 45.4119141,41.4673828 L43.0810547,39.6146484 C46.3083984,35.5804688 48.0117188,30.6395325 48.0117188,25.5 C48.0117188,13.1285156 37.8714844,2.98828125 25.5,2.98828125 C13.1285156,2.98828125 2.98828125,13.1285156 2.98828125,25.5 C2.98828125,37.8714844 13.1285156,48.0117188 25.5,48.0117188 C29.4445313,48.0117188 33.2994141,46.9658203 36.7060547,44.9935547 L38.2001953,47.5933594 C34.3453125,49.8345703 29.9525391,51 25.5,51 C11.4849609,51 0,39.5150391 0,25.5 C0,11.4849609 11.4849609,0 25.5,0 C39.5150391,0 51,11.4849609 51,25.5 Z",
    id: "Shape",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(25.500000, 0.000000)",
    fill: "#FF641A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2060547,44.9935547 L12.7001953,47.5933594 C8.8453125,49.8345703 4.45253906,51 0,51 L0,48.0117187 C3.94453125,48.0117187 7.79941406,46.9658203 11.2060547,44.9935547 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,25.5 C25.5,31.2371887 23.5277344,36.9849609 19.9119141,41.4673828 L17.5810547,39.6146484 C20.8083984,35.5804687 22.5117188,30.6395325 22.5117188,25.5 C22.5117188,13.1285156 12.3714844,2.98828125 0,2.98828125 L0,0 C14.0150391,0 25.5,11.4849609 25.5,25.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "25.5 42.0351562 16.5351562 42.0351562 16.5351562 33.0703125 19.5234375 33.0703125 19.5234375 39.046875 25.5 39.046875"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrum);
export default __webpack_public_path__ + "static/media/scrum.7f8da4bca818941e2846b536ef424daa.svg";
export { ForwardRef as ReactComponent };